<!-- svelte-ignore a11y-missing-attribute -->
<Secure>
  {#if $appState.user?.isAdmin}
    {#if $appState.user?.company}
    <div class="level has-background-primary p-2">
      <div class="level-item">
        <p>
        You are also acting as a business. <a on:click={switchView}>Switch to business view</a> or <a on:click={endAccess}>Stop acting as the business</a>
        </p>
      </div>
    </div>
    {:else if $appState.user?.charity}
    <div class="level has-background-primary p-2">
      <div class="level-item">
        <p>
        You are also acting as a charity. <a on:click={switchView}>Switch to charity view</a> or <a on:click={endAccess}>Stop acting as the charity</a>
        </p>
      </div>
    </div>
    {/if}
    <Nav />
    <div class="section">
      <div class="container">
        {#if $uiState.activeModal}
          <svelte:component
            this={$uiState.activeModal.component}
            {...$uiState.activeModal.props}
          />
        {/if}

        <slot />
      </div>
    </div>
  {:else}
  <div class="section">
    <div class="container">
    <p>
      Sorry, this area is for admin users only. Return to the <a href="/"
        >app homepage</a
      >.
    </p>
    </div>
    </div>
  {/if}
</Secure>

<script lang="ts">
  import Secure from "../_components/Secure.svelte";
  import Nav from "./_components/Nav.svelte";

  import { appState } from "../../lib/appState";
  import { uiState } from "../../lib/uiState";
  import { goto } from "@sveltech/routify";

  let firebase = window.firebase;

  function switchView() {
    if($appState.user?.company)
    {
      $goto('/business');
    } else {
      $goto('/charity');
    }
  }

  function endAccess() {
    firebase
      .firestore()
      .collection("users_v1")
      .doc($appState.auth_user.email)
      .update({
        company: firebase.firestore.FieldValue.delete(),
        charity: firebase.firestore.FieldValue.delete()
      })
      .then(() => {
        $appState.user!.company = undefined;
        $appState.user!.charity = undefined;
        $appState.company = undefined;
        $appState.charity = undefined;
        $goto("/admin");
      });
  }
</script>
